export const SET_EXPERIMENTS = 'experiments/SET';

export const setExperiments = payload => dispatch => {
  dispatch({ type: SET_EXPERIMENTS, payload });
  return Promise.resolve();
};
